import { Component, Output, EventEmitter, Input } from '@angular/core';
import { LocalStorageManager } from '../../../utils/local-storage-manager/local-storage-manager.utils';

@Component({
  selector: 'app-modal-color-selector',
  templateUrl: './modal-color-selector.component.html',
  styleUrls: ['./modal-color-selector.component.css']
})
export class ModalColorSelectorComponent  {

  isDarkmode = LocalStorageManager.isDarkmode;

  @Input() textTitle!: string;
  @Output() color_hex = new EventEmitter<string>();

  colorPallete: ColorPallete[] = [
    {
      name: 'red',
      colors: [ 'B71C1C', 'C62828', 'D32F2F', 'E53935', 'F44336', 'EF5350', 'E57373', 'EF9A9A' ]
    },
    {
      name: 'pink',
      colors: [ '880E4F', 'AD1457', 'C2185B', 'D81B60', 'E91E63', 'EC407A', 'F06292', 'F48FB1' ]
    },
    {
      name: 'purple',
      colors: [ '4A148C', '6A1B9A', '7B1FA2', '8E24AA', '9C27B0', 'AB47BC', 'BA68C8', 'CE93D8' ]
    },
    {
      name: 'darkpurple',
      colors: [ '311B92', '4527A0', '512DA8', '5E35B1', '673AB7', '7E57C2', '9575CD', 'B39DDB' ]
    },
    {
      name: 'darkblue',
      colors:[ '1A237E', '283593', '303F9F', '3949AB', '3F51B5', '5C6BC0', '7986CB', '9FA8DA' ]
    },
    {
      name: 'blue',
      colors: [ '0D47A1', '1565C0', '1976D2', '1E88E5', '2196F3', '42A5F5', '64B5F6', '90CAF9' ]
    },
    {
      name: 'cyan',
      colors: [ '006064', '00838F', '0097A7', '00ACC1', '00BCD4', '26C6DA', '4DD0E1', '80DEEA' ]
    },
    {
      name: 'darkcyan',
      colors: [ '004D40', '00695C', '00796B', '00897B', '009688', '26A69A', '4DB6AC', '80CBC4' ]
    },
    {
      name: 'green',
      colors: [ '1B5E20', '2E7D32', '388E3C', '43A047', '4CAF50', '66BB6A', '81C784', 'A5D6A7' ]
    },
    {
      name: 'darkyellow',
      colors: [ '827717', '9E9D24', 'AFB42B', 'C0CA33', 'CDDC39', 'D4E157', 'DCE775', 'E6EE9C' ]
    },
    {
      name: 'lightorange',
      colors: [ 'F57F17', 'F9A825', 'FBC02D', 'FDD835', 'FFEB3B', 'FFEE58', 'FFF176', 'FFF59D' ]
    },
    {
      name: 'orange',
      colors: [ 'E65100', 'EF6C00', 'F57C00', 'FB8C00', 'FF9800', 'FFA726', 'FFB74D', 'FFCC80' ]
    },
    {
      name: 'brown',
      colors: [ '3E2723', '4E342E', '5D4037', '6D4C41', '795548', '8D6E63', 'A1887F', 'BCAAA4' ]
    },
    {
      name: 'black',
      colors: [ '212121', '424242', '616161', '757575', '9E9E9E', 'BDBDBD', 'E0E0E0', 'EEEEEE' ]
    },
    {
      name: 'darkgray',
      colors: [ '263238', '37474F', '455A64', '546E7A', '607D8B', '78909C', '90A4AE', 'B0BEC5' ]
    }
  ]

  setColor(hex: string) {
    this.color_hex.emit(hex);
  }

}

interface ColorPallete {
  name: string;
  colors: string[];
}